import { API, METHODS } from '../../constants';
import { fetchData } from '../common/apiCalling';
import { constructURL } from '../common';
import { isEmpty } from 'lodash';

export const getAllAccountReviewsAPI = async ({ accountId, filter, offset, limit, search }) => {
    const queryParams = {
        account_id: accountId,
        offset: offset ? offset : undefined,
        limit: limit ? limit : '',
        search: search ? encodeURIComponent(search) : '',
        filter: !isEmpty(filter) ? encodeURIComponent(JSON.stringify(filter)) : '',
    };
    const url = constructURL(API.ACCOUNT_REVIEWS, queryParams);
    return fetchData({ method: METHODS.GET, url });
};

export const getAccountReviewByIdAPI = async ({ id }) => {
    return fetchData({ method: METHODS.GET, url: `${API.ACCOUNT_REVIEWS}/${id}` });
};

export const createAccountReviewAPI = async ({ accountId, title, content }) => {
    if (!accountId && !content) {
        throw new Error('createAccountReviewAPI: account_id and content is required');
    }
    const body = {
        account_id: accountId || undefined,
        title: title || undefined,
        content: content || undefined,
    };
    return fetchData({ body, method: METHODS.POST, url: API.ACCOUNT_REVIEWS });
};

export const updateAccountReviewAPI = async ({ id, accountId, title, content }) => {
    if (!accountId || !id) {
        throw new Error('createAccountReviewAPI: account_id and id is required');
    }
    const body = {
        account_id: accountId,
        title: title,
        content: content,
    };
    return fetchData({ body, method: METHODS.PUT, url: `${API.ACCOUNT_REVIEWS}/${id}` });
};

export const deleteAccountReviewAPI = async ({ id }) => {
    if (!id) {
        throw new Error('createAccountReviewAPI: id is required');
    }

    return fetchData({ method: METHODS.DELETE, url: `${API.ACCOUNT_REVIEWS}/${id}` });
};
